export class IncidentInsertCommand {
    public idOrganismo!: number;
    public incidencia!: string;
    public guidRel!: string;
}
